module.exports = __webpack_public_path__ + "static/media/shapeShift.c3112a5f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Pair/scenes/Amount/img/shapeShift.svg
// module id = 180
// module chunks = 0